module.exports = __webpack_public_path__ + "static/media/paydayColorLogoText.210d2ed3.png";